export const signup = {
  normal: {
    resetPasswordSubmit: 'page.resetPassword.ResetPasswordButtonClicked',
    otp: 'page.signup.step.otp',
    signup: 'page.signup.step.signup',
    password: 'page.signup.step.password',
    userProfile: 'page.signup.step.userProfile',
    otpLanding: 'page.signup.OtpLandingPage',
    otpSubmit: 'page.signup.VerifyOTPButtonClicked',
    passwordLanding: 'page.signin.passwordLanding',
    passwordSubmit: 'page.signup.CreatePasswordButtonClicked',
    signupsubmit: 'page.signup.CreateTeamButtonClicked',
    userProfileSubmit: 'page.signup.UserProfileSubmitButtonClicked'
  },
  databricks: {
    pageLanding: 'page.signup.databricksLandingPage',
    createPasswordSuccess: 'page.dbsignup.createPasswordSuccess'
  }
};
